import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';

import NewWifi from './NewWifi';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

export default class WifiList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_numbers: [],
      all_rooms: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      isDemoLogin: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 10;
  componentDidMount() {
    this.getAllRooms();
    this.getAllNumbers(this.state.current_offset);
    window.addEventListener('updateWifiTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  getAllRooms() {
    let user = ls.getUserDetails()
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i.hotel_room_id._id;
            }
          }
          this.setState({
            all_rooms: data,
          })
        }, error => {
          console.log(error);
        })
    }
  }

  refreshTable(e) {
    this.getAllNumbers(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  onChangePage(e) {
    this.getAllNumbers(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  getAllNumbers(offset, offset_change = 0) {
    const userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };

    ds.getAllWifiList(userData.hotel_id, 10, offset,
      data => {
        this.setState({
          all_numbers: data,
          totalCount: data.length
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, 
      err => {}
    )
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
    if (refresh) {
      this.getAllNumbers(0);
    }
  }

  editNumber(row, e) {
    this.setState({
      dialog: {
        open: true,
        body: <NewWifi details={row} unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    })
  }

  deleteNumber(row, e) {
    const userData = ls.getUserDetails();
    this.setState({
      dialog: {
        open: true,
        head: 'Delete?',
        body: 'Delete Wifi permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteWifi({ contact_id: row._id , hotel_id :userData.hotel_id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getAllNumbers(x > 0 ? x : 0, 1);
                }, err => {
                  console.log(err);
                });
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Rooms Wifi List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Room">Room</TableHeaderColumn>
                <TableHeaderColumn tooltip="Wifi Name">Wifi Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_numbers.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn style={{whiteSpace:'normal'}}>{
                        this.state.all_rooms.map((i)=>{
                            if(row.rooms.includes(i.value)){
                                return i.label
                            }
                        })
                    }</TableRowColumn>
                    <TableRowColumn>{row.ssid}</TableRowColumn>

                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editNumber.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      {
                        this.state.isDemoLogin === false?
                          <i className="material-icons warn-fg"
                            style={{cursor:'pointer'}}
                            onClick={this.deleteNumber.bind(this, row)}
                          >
                            delete
                          </i>
                        : null
                      }
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter></TableFooter>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/wifi/WifiList.js